import React from 'react';

export const Address = ({ place }: AdresseProps) => {
  return (
    <div className={'flex flex-col'}>

      <span>{place.adresse}</span>

      {(!!place.complementAdresse) && (
        <span>{place.complementAdresse}</span>
      )}

      <div className={'flex gap-1'}>

        <span>{place.codePostal}</span>

        <span>{place.ville}</span>
      </div>
    </div>
  );
};

interface AdresseProps {
  place: Place;
}

export interface Place {
  adresse: string;
  complementAdresse?: string;
  codePostal: string;
  ville: string;
}